import {keymap} from "prosemirror-keymap"
import {history} from "prosemirror-history"
import {baseKeymap} from "prosemirror-commands"
import {Plugin} from "prosemirror-state"
import {dropCursor} from "prosemirror-dropcursor"
import {gapCursor} from "prosemirror-gapcursor"
import {menuBar} from "prosemirror-menu"

import {buildMenuItems} from "./menu"
import {buildKeymap} from "./keymap"
import {buildInputRules} from "./inputrules"

import {EditorState} from "prosemirror-state"
import {EditorView} from "prosemirror-view"
import {Schema, DOMParser} from "prosemirror-model"
import {schema} from "prosemirror-schema-basic"
import {addListNodes} from "prosemirror-schema-list"

export {buildMenuItems, buildKeymap, buildInputRules}

let editorstate = {
    entity: '',
    id_entity: 0
}


let getMySchema = function() {
	schema.spec.nodes.content.push("mediaimage");
    schema.spec.nodes.content.push({
        inline: true,
        attrs: {
            // src: {default: null},
            alt: {default: null},
            title: {default: null},
            id_image: {default: null},
        },
        group: "inline",
        draggable: true,
        parseDOM: [{tag: "ct-image", getAttrs(dom) {
          return {
            // src: dom.getAttribute("src"),
            title: dom.getAttribute("title"),
            alt: dom.getAttribute("alt"),
            id_image: dom.getAttribute("id_image")
          }
        }}],
        toDOM(node) { let {alt, title, id_image} = node.attrs; return ["ct-image", {alt, title, id_image}] }
    });

    schema.spec.nodes.content.push("mediavideo");
    schema.spec.nodes.content.push({
        inline: true,
        attrs: {
            alt: {default: null},
            title: {default: null},
            id_video: {default: null},
        },
        group: "inline",
        draggable: true,
        parseDOM: [{tag: "ct-video", getAttrs(dom) {
          return {
            title: dom.getAttribute("title"),
            alt: dom.getAttribute("alt"),
            id_video: dom.getAttribute("id_video")
          }
        }}],
        toDOM(node) { let {alt, title, id_video} = node.attrs; return ["ct-video", {alt, title, id_video}] }
    });

    const mySchema = new Schema({
        nodes: addListNodes(schema.spec.nodes, "paragraph block*", "block"),
        marks: schema.spec.marks
    })

    return mySchema;
}

let parseFromSchema = function(schema, from) {
	if (typeof from == 'undefined' || from == '') {
		console.log("ERROR PARSE FROM SCHEMA: wrong selector 'from'");
	} 

	return DOMParser.fromSchema(schema).parse(document.querySelector(from))
}

let init = function (editorContainer, contentContainer, entity, id_entity){
    editorstate.entity = entity;
    editorstate.id_entity = id_entity;


	let schema = getMySchema()

	if (typeof contentContainer == 'undefined' || contentContainer == '') {
		contentContainer = editorContainer;
	}

	let doc = parseFromSchema(schema, contentContainer)

	let plugins = [
		buildInputRules(schema),
		keymap(buildKeymap(schema)),
		keymap(baseKeymap),
		dropCursor(),
		gapCursor(),
		menuBar({floating: true, content: buildMenuItems(schema, editorstate).fullMenu})
	]

	plugins = plugins.concat(new Plugin({
		props: {
			attributes: {class: "ProseMirror-example-setup-style"}
		}
	}));

    // window.view = new EditorView(document.querySelector(editorContainer), {
    //   	state: EditorState.create({
    //     	doc: doc,
    //     	plugins: plugins
    //   	})
    // })

    return new EditorView(document.querySelector(editorContainer), {
      	state: EditorState.create({
        	doc: doc,
        	plugins: plugins
      	})
    })
}



module.exports = {
    init: init,
    parseFromSchema: parseFromSchema
}